import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { AuthenticationState } from '../../reducers/authentication';

const useAuthentication = (): AuthenticationState => {
  return useSelector((state: RootState) => state.authentication);
};

export default useAuthentication;
